import { BillingTypeModel } from "../../billing/models/BillingTypeModel";
import { SubscriberModel } from "../../subscriber/models/SubscriberModel";
import { SellerModel } from "./SellerModel";

export class SellerComissionModel {
    paymentDate: string = ""
    percentage: number = 0
    totalComission: number = 0
    total: number = 0
    subscriber: SubscriberModel = new SubscriberModel()
    sellerSubscriber: SellerModel = new SellerModel()
    partnerEmployee: SellerModel = new SellerModel()
    type: BillingTypeModel = new BillingTypeModel()    
    description: string = ''
    partnerComission: number = 0
    partnerPercentageComission: number = 0
    employeePercentage: number = 0

    constructor(s?:Partial<SellerComissionModel>) {
        Object.assign(this, s)

        this._parseSubscriber()
        this._parseSellerSubscriber()
        this._parsePartnerEmployee()
        this._parseBillingType()
    }

    private _parseSubscriber():void {
        this.subscriber = new SubscriberModel(this.subscriber)
    }

    private _parseSellerSubscriber():void {
        this.sellerSubscriber = new SellerModel(this.sellerSubscriber)
    }

    private _parsePartnerEmployee():void {
        this.partnerEmployee = new SellerModel(this.partnerEmployee)
    }

    private _parseBillingType():void {
        this.type = new BillingTypeModel(this.type)
    }
}
